// @flow

import { trackingDashboardActions } from '../../../bulkCn/dashboard/trackingDashboardRedux/trackingDashboardActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  dashboardData: [],
  dashboardDataFiltered: [],
  error: null
};

const filterDashboardTableData = (newState, searchStr) => {
  const searchString = searchStr.trim();

  let filteredArr;

  if (searchString) {
    filteredArr = newState.dashboardData.filter(
      row =>
        row.cnote &&
        row.cnote.toString() &&
        row.cnote.toString().indexOf(searchString) >= 0
    );
  } else {
    filteredArr = newState.dashboardData;
  }

  return filteredArr;
};

const trackingDashboardReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case trackingDashboardActions.SET_TRACK_DASHBOARD_DATE_RANGE: {
      return Object.assign({}, state, action.payload);
    }
    case trackingDashboardActions.GET_DASHBOARD_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case trackingDashboardActions.FILTER_DASHBOARD_DATA: {
      const newState = Object.assign({}, state);
      const filtered = filterDashboardTableData(newState, action.payload);
      return Object.assign({}, state, { dashboardDataFiltered: filtered });
    }
    default: {
      return state;
    }
  }
};

export default trackingDashboardReducer;
